module.exports = __webpack_public_path__ + "img/pump-2.5aebfe04.png";